// 企业审核模块

//获取所有待审核的企业列表
function entApplyList(currpage = 1, status = '', countNum = 10) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetEntChkList", currpage, status, countNum, qerystr: "" },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status == "ok" ? { totalnum: str.totalnum, list: str.msg } : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//通过/拒绝企业审核
function validateCompany(strentid, entApprove) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSetEntChkList", entid: strentid, entApprove },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? { totalnum: str.totalnum, list: str.msg } : false);
      }
    });
  });
}

//获取企业发布的职位审核列表
function entValidateJob(countnum = 10, currpage = 1) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "entWorkProgress", currpage, countnum },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status === "ok" ? str.msg : false);
      }
    });
  });
}

//通过企业职位
function passEntJob(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "passentjob", msg: { jobid } },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status === "ok" ? str.msg : false);
      }
    });
  });
}

//拒绝企业职位
function refuseEntJob(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "closeentjob", msg: { content: "", jobid } },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status === "ok" ? str.msg : false);
      }
    });
  });
}

export default {
  entApplyList,
  validateCompany,
  entValidateJob,
  passEntJob,
  refuseEntJob
};
